module.exports = __webpack_public_path__ + "img/Chats.751e9f2f.svg";